import React from 'react'
import { DatePicker } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'
import dayjs, { Dayjs } from 'dayjs'

type YearPickerProps = Omit<React.ComponentProps<typeof DatePicker>, 'value' | 'onChange'> & {
  value?: number | null
  onChange?: (val?: number | null) => void
}

type AntdFormYearPickerProps = React.ComponentProps<typeof DatePicker> & AntdFormItemProps

export const YearPicker: React.FC<YearPickerProps> = ({
  value,
  onChange,
  ...props
}) => {
  const handleChange = (value?: number) => {
    onChange?.(value ? value : undefined)
  }

  return (
    <DatePicker
      {...props}
      value={value ? dayjs().year(value) : undefined}
      onChange={(dayjsObj) => {
        if (dayjsObj) {
          handleChange((dayjsObj as Dayjs).year())
        } else {
          handleChange(undefined)
        }
      }}
      format="YYYY"
      picker="year"
      multiple={false}
    />
  )
}

export const AntdFormYearPicker: React.FC<AntdFormYearPickerProps> = ({
  fieldProps,
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  value,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <YearPicker {...props} className={cn('w-full', className)} />
    </AntdFormItem>
  )
}


